import { useEffect, useMemo } from 'react';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import {
  togglePinnedFiltersState,
  selectReservationsPinnedFilters,
} from '@store';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import PersonIcon from '@mui/icons-material/Person';

export const useReservationsFilterConfig = ({ enums }) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const pinnedFilters = useSelector(selectReservationsPinnedFilters);
  const isErfuddAlert = router.query.isErfuddAlert === 'true';

  const filterCategories = useMemo(
    () => [
      {
        id: 'type',
        label: 'Reservation Type',
        icon: RadioButtonUncheckedIcon,
        options: enums?.types || [],
        multiSelect: false,
      },
      {
        id: 'agent',
        label: 'Agent',
        icon: PersonIcon,
        options: enums?.agents || [],
        multiSelect: false,
      },
      {
        id: 'subscriptionType',
        label: 'Subscription Type',
        icon: RadioButtonUncheckedIcon,
        options: enums?.subscriptionTypes || [],
        multiSelect: false,
      },
    ],
    [enums]
  );
  const handlePinnedFilterSelect = (pinnedFilter) => {
    dispatch(togglePinnedFiltersState({ board: 'reservations', pinnedFilter }));
  };

  const parseQueryValue = (value) => {
    if (!value) return [];
    if (typeof value === 'string') {
      return value.split(',').filter(Boolean);
    }
    return Array.isArray(value) ? value : [];
  };

  useEffect(() => {
    if (!isErfuddAlert) return;

    const queryType = parseQueryValue(router.query.type);
    if (queryType.length === 0 || queryType.length > 1) return;

    const nextQuery = { ...router.query };
    delete nextQuery.isErfuddAlert;

    router.replace({ pathname: router.pathname, query: nextQuery }, undefined, {
      shallow: true,
    });
  }, [isErfuddAlert, router]);

  const currentFilters = useMemo(() => {
    const queryType = parseQueryValue(router.query.type);

    return {
      type: queryType.length > 1 ? [] : queryType,
      agent: parseQueryValue(router.query.agent),
      subscriptionType: parseQueryValue(router.query.subscriptionType),
    };
  }, [router.query]);

  return {
    filterCategories,
    currentFilters,
    handlePinnedFilterSelect,
    pinnedFilters,
    supportPinnedFilters: true,
  };
};
